export default __webpack_public_path__ + "static/media/innovation-laboratories.61f587e0.png";